import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'boxes-linked',
  size: 24,
  node: [
    ['path', { d: 'M14 6h2a2 2 0 0 1 2 2v5', key: 'dpdf3h' }],
    ['path', { d: 'M14.21 15.202 18 17.4V22', key: '643eh2' }],
    [
      'path',
      {
        d: 'M14.796 14.611A1.6 1.6 0 0 0 14 15.995v3.013a1.6 1.6 0 0 0 .797 1.384l2.4 1.392a1.6 1.6 0 0 0 1.606 0l2.4-1.392A1.6 1.6 0 0 0 22 19.008v-3.013a1.6 1.6 0 0 0-.796-1.384l-2.4-1.394a1.6 1.6 0 0 0-1.514-.051z',
        key: 'g76p55',
      },
    ],
    ['path', { d: 'm18 17.4 3.79-2.198', key: '9mu234' }],
    ['path', { d: 'M2.21 4.202 6 6.4V16a2 2 0 0 0 2 2h2', key: '1qwzoc' }],
    [
      'path',
      {
        d: 'M2.796 3.611A1.6 1.6 0 0 0 2 4.995v3.013a1.6 1.6 0 0 0 .797 1.384l2.4 1.392a1.6 1.6 0 0 0 1.606 0l2.4-1.392A1.6 1.6 0 0 0 10 8.008V4.995a1.6 1.6 0 0 0-.796-1.384l-2.4-1.394a1.6 1.6 0 0 0-1.514-.052z',
        key: 'cbb3m8',
      },
    ],
    ['path', { d: 'm6 6.4 3.79-2.198', key: '11cxrz' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name BoxesLinked
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgNmgyYTIgMiAwIDAgMSAyIDJ2NSIgLz4KICA8cGF0aCBkPSJNMTQuMjEgMTUuMjAyIDE4IDE3LjRWMjIiIC8+CiAgPHBhdGggZD0iTTE0Ljc5NiAxNC42MTFBMS42IDEuNiAwIDAgMCAxNCAxNS45OTV2My4wMTNhMS42IDEuNiAwIDAgMCAuNzk3IDEuMzg0bDIuNCAxLjM5MmExLjYgMS42IDAgMCAwIDEuNjA2IDBsMi40LTEuMzkyQTEuNiAxLjYgMCAwIDAgMjIgMTkuMDA4di0zLjAxM2ExLjYgMS42IDAgMCAwLS43OTYtMS4zODRsLTIuNC0xLjM5NGExLjYgMS42IDAgMCAwLTEuNTE0LS4wNTF6IiAvPgogIDxwYXRoIGQ9Im0xOCAxNy40IDMuNzktMi4xOTgiIC8+CiAgPHBhdGggZD0iTTIuMjEgNC4yMDIgNiA2LjRWMTZhMiAyIDAgMCAwIDIgMmgyIiAvPgogIDxwYXRoIGQ9Ik0yLjc5NiAzLjYxMUExLjYgMS42IDAgMCAwIDIgNC45OTV2My4wMTNhMS42IDEuNiAwIDAgMCAuNzk3IDEuMzg0bDIuNCAxLjM5MmExLjYgMS42IDAgMCAwIDEuNjA2IDBsMi40LTEuMzkyQTEuNiAxLjYgMCAwIDAgMTAgOC4wMDhWNC45OTVhMS42IDEuNiAwIDAgMC0uNzk2LTEuMzg0bC0yLjQtMS4zOTRhMS42IDEuNiAwIDAgMC0xLjUxNC0uMDUyeiIgLz4KICA8cGF0aCBkPSJtNiA2LjQgMy43OS0yLjE5OCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/boxes-linked
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BoxesLinked = createLucideIcon(__iconData);

export default BoxesLinked;
